import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
    apiKey: 'AIzaSyABDONppFXtErQ-7Zd-MBjDr2Myvi7DIb8',
    authDomain: 'tuhi-development.firebaseapp.com',
    projectId: 'tuhi-development',
    storageBucket: 'tuhi-development.appspot.com',
    messagingSenderId: '928718096009',
    appId: '1:928718096009:web:f32e894ad598837ac3e858',
    measurementId: 'G-71K9LEQH92',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)
